import { defineComponent as _defineComponent } from 'vue'
import { Icon, Upload } from 'ant-design-vue'
import { ref, watch } from 'vue'
import { uploadFile } from '@/api/common'
import { get, last } from 'lodash'

type Props = {
  value?: string | string[] | { url: string; name: string }[]
  disabled?: boolean
  accept?: string
  limit?: number
  listType?: 'text' | 'picture' | 'picture-card'
}

type FileType = {
  name: string
  url: string
  thumbUrl?: string
  status?: string
  response?: string
}
interface UploadRequestOption<T = any> {
  /**
   * @description
   * @example option.onProgress({ percent: 50 }) 已上传50%
   */
  onProgress: (event: { percent: number }) => void

  /**
   * @description 上传失败回调函数
   * @example option.onError({ status: 500, method: 'POST', url: 'xxx' })
   */
  onError: (event: AnyObject) => void

  /**
   * @description 上传成功回调函数
   * @example option.onSuccess(res.data)
   */
  onSuccess: (url: string, xhr: AnyObject) => void

  /**
   * @description 由Upload组件的props:data 指定的额外参数
   */
  data?: object

  /**
   * @description 文件名
   * @example xxx.png
   */
  filename?: string

  /**
   * @description 文件数据
   */
  file: File

  /**
   * @description 若上传的目标站点与当前站点不一样，是否携带cookie
   */
  withCredentials?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FileUpload',
  props: {
    value: null,
    disabled: { type: Boolean },
    accept: null,
    limit: { default: 5 },
    listType: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { value?: string | string[] | { url: string; name: string }[], disabled?: boolean, accept?: string, limit: number, listType?: 'text' | 'picture' | 'picture-card' };




const fileList = ref<FileType[]>([])
const loading = ref(false)

watch(
  () => fileList,
  (val) => {
    /** 应该过滤成功的，这边演示所以先过滤缩略图 */
    const filter = val.value.filter((i) => i.status === 'done')

    emit(
      'input',
      filter.map((i) => ({
        ...i,
        url: i.url || i.response,
        fileName: i.url || i.response,
      }))
    )
  },
  {
    deep: true,
  }
)

watch(
  () => props.value,
  (val) => {
    if (Array.isArray(val) && val.length && fileList.value.length === 0) {
      const list = [] as FileType[]
      val.forEach((item) => {
        if (item) {
          if (typeof item === 'string') {
            list.push({
              name: last(item.split('/')) || '',
              url: item,
            })
          } else if (typeof item === 'object') {
            list.push({
              name: item.name,
              url: item.url,
            })
          }
        }
      })

      fileList.value = list
    }
  },
  {
    deep: true,
    immediate: true,
  }
)

function handlePreview(file: FileType) {
  console.log(file)
  if (file.url) {
    window.open(file.url + '?preview=true', '_blank')
  }
}

async function beforeUpload(data: UploadRequestOption) {
  loading.value = true
  const file = data.file

  uploadFile({ file })
    .then((response) => {
      if (response.code === 200) {
        data.onSuccess(response.fileName, response)
      }
    })
    .catch((err) => {
      data.onError(err)
    })
    .finally(() => {
      loading.value = false
    })
}

function handleChange(data: AnyObject) {
  fileList.value = data.fileList
}

return { __sfc: true,props, emit, fileList, loading, handlePreview, beforeUpload, handleChange, Icon, Upload }
}

})